// import React from "react";
// import { Navigate } from "react-router-dom";

// interface ProtectedRouteProps {
//   element: React.ReactElement;
// }

// const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
//   const isAuthenticated = localStorage.getItem("loginToken");
//   if (!isAuthenticated) {
//     return;
//   }


//   return element;
// };

// export default ProtectedRoute;
import React from "react";

interface ProtectedRouteProps {
  element: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  
  return element;  
};

export default ProtectedRoute;
